var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const EnvConfig = {
  PORT: 9e3,
  HOST: "localhost",
  SERVERHOST: "0.0.0.0",
  SERVERNAME: "networkinglive",
  SERVERORIGIN: `networkinglive.utsubo.io`,
  FIRESTORE_KEY_FLAG: "multiplayerlocal",
  SKIP_FIRESTORE_EVENTS: false
};
const MESSAGE_TYPE_BYTE_LENGTH = 1;
const FLOAT_BYTE_LENGTH = 4;
const SLOTID_BYTE_LENGTH = 2;
const POSITION_COMPONENTS = 3;
const ROTATION_COMPONENTS = 1;
const PLAYER_DATA_COMPONENTS = POSITION_COMPONENTS + ROTATION_COMPONENTS;
const PLAYER_DATA_BYTE_LENGTH = PLAYER_DATA_COMPONENTS * FLOAT_BYTE_LENGTH;
const PLAYER_SLOT_BYTE_LENGTH = SLOTID_BYTE_LENGTH + PLAYER_DATA_BYTE_LENGTH;
const MAX_PLAYERS_PER_THREAD_DEFAULT = 1e3;
const MAX_PLAYERS_PER_ROOM_DEFAULT = 100;
const UPDATE_HZ = 24;
const UPDATE_INTERVAL_MS = 1e3 / UPDATE_HZ;
const DataSizes = {
  MESSAGE_TYPE_BYTE_LENGTH,
  SLOTID_BYTE_LENGTH,
  POSITION_COMPONENTS,
  ROTATION_COMPONENTS,
  PLAYER_DATA_COMPONENTS,
  FLOAT_BYTE_LENGTH,
  PLAYER_DATA_BYTE_LENGTH,
  PLAYER_SLOT_BYTE_LENGTH,
  MAX_PLAYERS_PER_THREAD_DEFAULT,
  MAX_PLAYERS_PER_ROOM_DEFAULT,
  UPDATE_HZ,
  UPDATE_INTERVAL_MS
};
var Messages = /* @__PURE__ */ ((Messages2) => {
  Messages2[Messages2["FRAME_COMPLETE"] = 0] = "FRAME_COMPLETE";
  Messages2[Messages2["FRAME_DIFF"] = 1] = "FRAME_DIFF";
  Messages2[Messages2["CONNECT"] = 2] = "CONNECT";
  Messages2[Messages2["NEW_PLAYER"] = 3] = "NEW_PLAYER";
  Messages2[Messages2["PLAYER_MAPPING"] = 4] = "PLAYER_MAPPING";
  Messages2[Messages2["CUSTOM"] = 5] = "CUSTOM";
  Messages2[Messages2["SERVER_ANNOUNCEMENT"] = 6] = "SERVER_ANNOUNCEMENT";
  Messages2[Messages2["PING"] = 7] = "PING";
  Messages2[Messages2["PONG"] = 8] = "PONG";
  Messages2[Messages2["TOKEN_INVALID"] = 9] = "TOKEN_INVALID";
  Messages2[Messages2["ALREADY_CONNECTED"] = 10] = "ALREADY_CONNECTED";
  Messages2[Messages2["CUSTOM_ACK"] = 11] = "CUSTOM_ACK";
  return Messages2;
})(Messages || {});
class NetworkingClient {
  constructor(options) {
    __publicField(this, "_messageQueue", []);
    __publicField(this, "_isSending", false);
    __publicField(this, "ws");
    __publicField(this, "fullFrame", new ArrayBuffer(DataSizes.PLAYER_SLOT_BYTE_LENGTH * DataSizes.MAX_PLAYERS_PER_ROOM_DEFAULT));
    __publicField(this, "fullFrameView", new DataView(this.fullFrame));
    __publicField(this, "startTime");
    __publicField(this, "pingInterval", 1e3);
    __publicField(this, "maxPlayersPerRoom", DataSizes.MAX_PLAYERS_PER_ROOM_DEFAULT);
    __publicField(this, "maxPlayersPerThread", DataSizes.MAX_PLAYERS_PER_THREAD_DEFAULT);
    __publicField(this, "intervalLatencyId");
    __publicField(this, "_isConnected", false);
    __publicField(this, "playerId");
    __publicField(this, "token");
    __publicField(this, "decodedToken");
    __publicField(this, "isTabActive", true);
    __publicField(this, "playerIdToSlotIdMapping", /* @__PURE__ */ new Map());
    __publicField(this, "slotIdToPlayerIdMapping", /* @__PURE__ */ new Map());
    __publicField(this, "connectionState");
    __publicField(this, "reconnectIntervals");
    __publicField(this, "_onNewFrameData");
    __publicField(this, "_onNewPlayerData");
    __publicField(this, "_onTokenInvalid");
    __publicField(this, "_getStartPosition");
    __publicField(this, "_onPlayerJoin");
    __publicField(this, "_onPlayerLeave");
    __publicField(this, "_onCustomMessage");
    __publicField(this, "_onLatestLatency");
    __publicField(this, "_onServerAnnouncement");
    __publicField(this, "onError");
    __publicField(this, "onAlreadyConnected");
    __publicField(this, "onConnectionStatusChange");
    __publicField(this, "attempts");
    __publicField(this, "latency");
    __publicField(this, "handleVisibilityChange", () => {
      if (document.hidden) {
        this.isTabActive = false;
      } else {
        this.isTabActive = true;
        if (this.connectionState !== 2) {
          this.attemptReconnect();
        }
      }
    });
    __publicField(this, "microversePort", -1);
    __publicField(this, "hubPort", EnvConfig.PORT);
    this.options = options;
    this.connectionState = 0;
    this.attempts = 0;
    this.startTime = 0;
    this.pingInterval = options.pingInterval;
    this.latency = 0;
    this.intervalLatencyId = null;
    this.maxPlayersPerRoom = options.maxPlayersPerRoom || DataSizes.MAX_PLAYERS_PER_ROOM_DEFAULT;
    this.maxPlayersPerThread = options.maxPlayersPerThread || DataSizes.MAX_PLAYERS_PER_THREAD_DEFAULT;
    this.reconnectIntervals = [5, 10, 30, 60];
    this.onConnectionStatusChange = () => {
    };
    if (!this.options.token) {
      const networkClientToken = localStorage.getItem("nc_token");
      if (networkClientToken) {
        console.log(`${this.constructor.name}:`, "Using token from local storage");
        this.options.token = localStorage.getItem("nc_token");
      }
    }
    if (!options.playerId && !options.token) {
      throw new Error("You must provide either a playerId (in the case of an unauthenticated server) or a token");
    }
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
  }
  destroy() {
    this.disconnect();
    if (this.intervalLatencyId) {
      clearInterval(this.intervalLatencyId);
      this.intervalLatencyId = null;
    }
    if (typeof document !== "undefined") {
      document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    this._onNewFrameData = () => {
    };
    this._onNewPlayerData = null;
    this._onTokenInvalid = () => {
    };
    this._getStartPosition = () => [0, 0, 0];
    this._onPlayerJoin = null;
    this._onPlayerLeave = null;
    this._onCustomMessage = null;
    this._onLatestLatency = null;
    this._onServerAnnouncement = null;
    this.onError = null;
    this.onAlreadyConnected = null;
    this.onConnectionStatusChange = null;
  }
  onNewFrameData(onReceiveNewFrameData) {
    this._onNewFrameData = onReceiveNewFrameData;
  }
  onPlayerJoin(onPlayerJoin) {
    this._onPlayerJoin = onPlayerJoin;
  }
  onPlayerLeave(onPlayerLeave) {
    this._onPlayerLeave = onPlayerLeave;
  }
  onNewPlayerData(onNewPlayerData) {
    this._onNewPlayerData = onNewPlayerData;
  }
  onTokenInvalid(onTokenInvalid) {
    this._onTokenInvalid = onTokenInvalid;
  }
  getStartPosition(getStartPosition) {
    this._getStartPosition = getStartPosition;
  }
  onServerAnnouncement(onServerAnnouncement) {
    this._onServerAnnouncement = onServerAnnouncement;
  }
  async connect() {
    try {
      this.setConnectionState(1);
      if (this._isConnected) {
        this.setConnectionState(0);
        throw new Error("We should already be connected");
      }
      if (this.options.token) {
        try {
          this.extractTokenInfo();
        } catch (error) {
          throw new Error(`Failed to extract token info: ${error}`);
        }
      }
      console.log(`${this.constructor.name}:`, `Connecting...`);
      const websocketProtocol = this.options.secure ? "wss" : "ws";
      try {
        this.microversePort = await this.getOrCreateMicroverse(this.options.microverse);
      } catch (error) {
        throw new Error(`Failed to connect: ${error}`);
      }
      console.log(`${this.constructor.name}:`, `Connecting to port ${this.microversePort}...`);
      this.ws = new WebSocket(`${websocketProtocol}://${this.options.host}:${this.microversePort}`);
      if (!this.ws) {
        throw new Error("Failed to create WebSocket.");
      }
      await this.initWebsocket(this.options.playerId).catch((error) => {
        throw new Error(`WebSocket error: ${error}`);
      });
      return this;
    } catch (error) {
      console.error(`Failed to connect: ${error}`);
      this.setConnectionState(0);
      if (error.message === "Unauthorized") {
        console.log(`${this.constructor.name}:`, "Token expired or invalid, refreshing token and retrying connection...");
        this.reconnect();
      } else {
        throw error;
      }
    }
  }
  extractTokenInfo() {
    if (!this.token) {
      try {
        this.token = this.options.token;
        const parts = this.token.split(".");
        const payloadPart = parts[1];
        this.decodedToken = JSON.parse(atob(payloadPart));
      } catch (e) {
        throw new Error("Unable to read provided token");
      }
    }
  }
  initWebsocket(url) {
    return new Promise((resolve, reject) => {
      this.ws.onopen = () => {
        console.log(`${this.constructor.name}:`, `Connected on port ${this.microversePort}`);
        this.setConnectionState(2);
        if (this.intervalLatencyId) {
          clearInterval(this.intervalLatencyId);
        }
        if (this.ws.readyState === WebSocket.OPEN) {
          const data = {
            t: Messages.CONNECT,
            d: {
              token: `Bearer ${this.token}`,
              startPos: this._getStartPosition(),
              playerId: this.decodedToken?.user_id ?? this.options.playerId
            }
          };
          this.ws.send(JSON.stringify(data));
          this.intervalLatencyId = setInterval(() => {
            this.startTime = Date.now();
            if (this.ws.readyState === WebSocket.OPEN && this._isConnected) {
              this.ws.send(JSON.stringify({ t: Messages.PING }));
            }
          }, this.pingInterval || 1e3);
          this.setupMessageHandling();
        } else {
          reject(new Error(`WebSocket is not open. readyState: ${this.ws.readyState}`));
        }
        resolve(this);
      };
      this.ws.onclose = (event) => {
        if (this.intervalLatencyId) {
          clearInterval(this.intervalLatencyId);
        }
        if (event.wasClean) {
          console.log(`${this.constructor.name}:`, "WebSocket connection closed cleanly.");
        } else {
          console.log(`${this.constructor.name}:`, "WebSocket connection closed unexpectedly:", event);
          reject(new Error("WebSocket connection closed unexpectedly."));
        }
        console.log(`${this.constructor.name}:`, `Disconnected`);
        this.setConnectionState(0);
        this._isConnected = false;
      };
      this.ws.onerror = (errorEvent) => {
        if (this.onError) {
          this.onError(errorEvent);
        }
        console.log(`${this.constructor.name}:`, `WebSocket error observed: `, errorEvent);
        this.setConnectionState(0);
        this._isConnected = false;
        this.attemptReconnect().catch((error) => {
          console.error(`Reconnection attempt failed: ${error}`);
        });
        reject(new Error("WebSocket error."));
      };
    });
  }
  async getOrCreateMicroverse(microverse) {
    try {
      const httpProtocol = this.options.secure ? "https" : "http";
      const url = `${httpProtocol}://${this.options.host}:${this.hubPort}/microverse/${microverse}?maxPlayersPerRoom=${this.maxPlayersPerRoom}&maxPlayersPerThread=${this.maxPlayersPerThread}`;
      const headers = {
        "Authorization": `Bearer ${this.token}`
      };
      const response = await fetch(url, {
        headers,
        method: "GET"
      });
      switch (response.status) {
        case 200: {
          const json = await response.json();
          return json.port;
        }
        case 401: {
          console.log(`${this.constructor.name}:`, "401 - Token expired or invalid, refreshing token and retrying connection...");
          await this.reconnect();
        }
        case 204: {
          console.log(`${this.constructor.name}:`, `Microverse ${microverse} does not exist, creating...`);
          const postResponse = await fetch(url, {
            headers,
            method: "POST"
          });
          const json = await postResponse.json();
          return json.port;
        }
        default: {
          throw new Error(`Unknown error. Response: ${response.status}`);
        }
      }
    } catch (error) {
      console.log(error);
      const httpProtocol = this.options.secure ? "https" : "http";
      const url = `${httpProtocol}://${this.options.host}:${this.hubPort}/microverse/${microverse}`;
      if (error.name === "TypeError") {
        throw new Error(`There was a network error in the multiplayer Fetch to ${url}. ${error}`);
      } else {
        throw new Error(`An unexpected error happened in the multiplayer Fetch to ${url}. ${error}`);
      }
    }
  }
  disconnect() {
    console.log(`${this.constructor.name}:`, `Disconnecting...`);
    if (this.intervalLatencyId) {
      clearInterval(this.intervalLatencyId);
    }
    if (this.ws) {
      this.ws.close();
    }
    this.token = null;
    this._isConnected = false;
    this.setConnectionState(0);
    this.playerIdToSlotIdMapping.clear();
    this.slotIdToPlayerIdMapping.clear();
  }
  checkConnection() {
    if (!this.ws) {
      throw new Error("WebSocket does not exist");
    }
    switch (this.ws.readyState) {
      case WebSocket.CONNECTING:
        return "Connecting";
      case WebSocket.OPEN:
        return "Open";
      case WebSocket.CLOSING:
        return "Closing";
      case WebSocket.CLOSED:
        return "Closed";
      default:
        return "Unknown";
    }
  }
  async attemptReconnect() {
    if (this.connectionState === 2) {
      console.log(`${this.constructor.name}:`, "Already connected!");
      return;
    }
    this.attempts = 0;
    let interval;
    if (this.attempts >= this.reconnectIntervals.length) {
      interval = this.reconnectIntervals[this.reconnectIntervals.length - 1];
    } else {
      interval = this.reconnectIntervals[this.attempts];
    }
    while (this.attempts < this.reconnectIntervals.length && this.isTabActive) {
      try {
        console.log(`${this.constructor.name}:`, `Attempting to reconnect in ${interval} seconds...`);
        await new Promise((resolve) => setTimeout(resolve, interval * 1e3));
        await this.connect();
        break;
      } catch (error) {
        console.log(`${this.constructor.name}:`, `Reconnect attempt failed: ${error}`);
      }
      this.attempts++;
      interval = this.reconnectIntervals[this.attempts];
    }
  }
  async forceReconnect() {
    if (this.connectionState === 2) {
      console.log(`${this.constructor.name}:`, "Already connected!");
      return;
    }
    console.log(`${this.constructor.name}:`, "Forcing reconnect...");
    try {
      await this.connect();
      this.attempts = 0;
    } catch (error) {
      console.log(`${this.constructor.name}:`, `Force reconnect failed: ${error}`);
    }
  }
  async reconnect() {
    this.setConnectionState(1);
    try {
      this.disconnect();
      if (typeof this.options.refreshToken === "function") {
        console.log(`${this.constructor.name}:`, "Refreshing token...");
        this.options.token = await this.options.refreshToken();
      }
      return this.connect();
    } catch (refreshError) {
      throw new Error(`Failed to refresh token: ${refreshError}`);
    }
  }
  sendCustomMessage(message, toPlayerIds) {
    if (!this._isConnected) {
      return;
    }
    const payload = {
      t: Messages.CUSTOM,
      d: message
    };
    if (toPlayerIds) {
      payload.o = toPlayerIds;
    }
    this._messageQueue.push(payload);
    if (!this._isSending) {
      this._sendNextMessage();
    }
  }
  _sendNextMessage() {
    if (this._messageQueue.length === 0) {
      this._isSending = false;
      return;
    }
    const message = this._messageQueue.shift();
    if (message) {
      this._isSending = true;
      try {
        this.ws.send(JSON.stringify(message));
        this._sendNextMessage();
      } catch (error) {
        console.error("Failed to send message:", error);
        this._isSending = false;
      }
    }
  }
  onCustomMessage(onCustomMessage) {
    this._onCustomMessage = onCustomMessage;
  }
  onLatestLatency(onLatestLatency) {
    this._onLatestLatency = onLatestLatency;
  }
  getPort() {
    return this.microversePort;
  }
  getPlayerId() {
    return this.playerId;
  }
  isConnected() {
    return this._isConnected;
  }
  setConnectionState(state) {
    this.connectionState = state;
    if (this.onConnectionStatusChange) {
      this.onConnectionStatusChange(state);
    }
  }
  setupMessageHandling() {
    this.ws.onmessage = (event) => {
      if (event.data instanceof Blob) {
        this.handleBinaryMessage(event.data);
      } else if (typeof event.data === "string") {
        const json = (() => {
          try {
            return JSON.parse(event.data);
          } catch (e) {
            console.error(`Error parsing JSON: ${e}`);
          }
        })();
        json && this.handleJsonMessage(json);
      }
    };
  }
  handleBinaryMessage(binaryMessage) {
    binaryMessage.arrayBuffer().then((buffer) => {
      const incomingDataView = new DataView(buffer);
      const messageType = incomingDataView.getUint8(0);
      DataSizes.MESSAGE_TYPE_BYTE_LENGTH;
      switch (messageType) {
        case Messages.FRAME_COMPLETE: {
          this.fullFrame = buffer;
          this.fullFrameView = incomingDataView;
          this._onNewFrameData?.();
          break;
        }
        case Messages.FRAME_DIFF: {
          this.copyPartialToFull(incomingDataView);
          break;
        }
        default: {
          console.error(`Unknown message type: ${messageType}`);
        }
      }
    });
  }
  handleJsonMessage(jsonMessage) {
    switch (jsonMessage.t) {
      case Messages.PLAYER_MAPPING:
        const incomingArray = jsonMessage.d;
        const serverPlayerMapping = new Map(incomingArray.map((player) => [player.playerId, { roomId: player.roomId, slotId: player.slotId, lastPos: player.pos }]));
        serverPlayerMapping.forEach(({ slotId, lastPos, roomId }, playerId2) => {
          if (!this.playerIdToSlotIdMapping.has(playerId2)) {
            this.registerConnectedAs(playerId2, this.options.token ? this.decodedToken.user_id : this.options.playerId, lastPos, slotId, roomId);
          }
        });
        if (this._isConnected) {
          serverPlayerMapping.forEach(({ slotId, lastPos, roomId }, playerId2) => {
            if (!this.playerIdToSlotIdMapping.has(playerId2)) {
              this.playerIdToSlotIdMapping.set(playerId2, slotId);
              this.slotIdToPlayerIdMapping.set(slotId, playerId2);
              this._onPlayerJoin?.(playerId2, lastPos, roomId);
            }
          });
          this.playerIdToSlotIdMapping.forEach((slotId, playerId2) => {
            if (!serverPlayerMapping.has(playerId2)) {
              this.playerIdToSlotIdMapping.delete(playerId2);
              this.slotIdToPlayerIdMapping.delete(slotId);
              this._onPlayerLeave?.(playerId2);
            }
          });
        }
        window.playerMapping = this.playerIdToSlotIdMapping;
        break;
      case Messages.TOKEN_INVALID:
        console.log(`${this.constructor.name}:`, "Server answered 9 - Token expired or invalid, refreshing token and retrying connection...");
        this._onTokenInvalid?.();
        break;
      case Messages.NEW_PLAYER:
        break;
      case Messages.ALREADY_CONNECTED:
        console.log(`${this.constructor.name}:`, "Server answered 10 - Already connected, disconnecting...");
        this.disconnect();
        if (this.onAlreadyConnected) {
          this.onAlreadyConnected();
        }
      case Messages.CUSTOM:
        const playerId = jsonMessage.i;
        const toPlayerIds = jsonMessage.o;
        this._onCustomMessage?.(playerId, jsonMessage.d, toPlayerIds);
        break;
      case Messages.SERVER_ANNOUNCEMENT:
        this._onServerAnnouncement?.(jsonMessage.d);
        break;
      case Messages.PONG:
        const latency = Date.now() - this.startTime;
        this.latency = latency;
        this._onLatestLatency?.(latency);
        break;
    }
  }
  setPlayerData(playerId, copyPosition, copyRotation) {
    if (!this._isConnected) {
      return;
    }
    const slotId = this.playerIdToSlotIdMapping.get(playerId);
    this.copySlotToPositionAndRotation(slotId, copyPosition, copyRotation);
  }
  sendPlayerData(position, rotation) {
    if (!this._isConnected) {
      return;
    }
    const buffer = new ArrayBuffer(DataSizes.PLAYER_DATA_BYTE_LENGTH);
    const view = new DataView(buffer);
    let byteOffset = 0;
    const { FLOAT_BYTE_LENGTH: FLOAT_BYTE_LENGTH2 } = DataSizes;
    view.setFloat32(byteOffset, position.x);
    byteOffset += FLOAT_BYTE_LENGTH2;
    view.setFloat32(byteOffset, position.y);
    byteOffset += FLOAT_BYTE_LENGTH2;
    view.setFloat32(byteOffset, position.z);
    byteOffset += FLOAT_BYTE_LENGTH2;
    view.setFloat32(byteOffset, rotation.y);
    byteOffset += FLOAT_BYTE_LENGTH2;
    this.ws.send(view);
    return this;
  }
  copySlotToPositionAndRotation(slotId, position, rotation) {
    const dataView = this.fullFrameView;
    let byteOffset = slotId * DataSizes.PLAYER_SLOT_BYTE_LENGTH;
    byteOffset += DataSizes.SLOTID_BYTE_LENGTH;
    const { FLOAT_BYTE_LENGTH: FLOAT_BYTE_LENGTH2 } = DataSizes;
    const x = dataView.getFloat32(byteOffset);
    isNaN(x) || (position.x = x);
    byteOffset += FLOAT_BYTE_LENGTH2;
    const y = dataView.getFloat32(byteOffset);
    isNaN(y) || (position.y = y);
    byteOffset += FLOAT_BYTE_LENGTH2;
    const z = dataView.getFloat32(byteOffset);
    isNaN(z) || (position.z = z);
    byteOffset += FLOAT_BYTE_LENGTH2;
    const rY = dataView.getFloat32(byteOffset);
    isNaN(rY) || (rotation.y = rY);
  }
  copyPartialToFull(partialFrameView) {
    let readByteOffset = DataSizes.MESSAGE_TYPE_BYTE_LENGTH;
    const moreSlotsToRead = () => readByteOffset <= partialFrameView.byteLength - DataSizes.PLAYER_SLOT_BYTE_LENGTH;
    while (moreSlotsToRead()) {
      const slotId = partialFrameView.getUint16(readByteOffset);
      const copyToOffset = slotId * DataSizes.PLAYER_SLOT_BYTE_LENGTH + DataSizes.SLOTID_BYTE_LENGTH;
      const playerId = this.slotIdToPlayerIdMapping.get(slotId);
      if (playerId == null) {
        console.error(`It appears we have a slotId that is not mapped to a playerId.`);
      } else {
        this._onNewPlayerData?.(playerId, this.copySlotToPositionAndRotation.bind(this, slotId));
      }
      let internalPlayerDataOffset = 0;
      for (let j = 0; j < DataSizes.PLAYER_DATA_COMPONENTS; j++) {
        const getOffset = readByteOffset + DataSizes.SLOTID_BYTE_LENGTH + internalPlayerDataOffset;
        const setOffset = copyToOffset + internalPlayerDataOffset;
        this.fullFrameView.setFloat32(setOffset, partialFrameView.getFloat32(getOffset));
        internalPlayerDataOffset += DataSizes.FLOAT_BYTE_LENGTH;
      }
      readByteOffset += DataSizes.PLAYER_SLOT_BYTE_LENGTH;
    }
  }
  registerConnectedAs(playerId, userId, lastPos, slotId, roomId) {
    if (playerId === userId) {
      this.playerIdToSlotIdMapping.set(playerId, slotId);
      this.slotIdToPlayerIdMapping.set(slotId, playerId);
      console.log(`${this.constructor.name}:`, `Websocket user authenticated and connected with id ${playerId} and slotId ${slotId}`);
      this._onPlayerJoin?.(playerId, lastPos, roomId);
      this.playerId = playerId;
      this._isConnected = true;
    }
  }
}
export {
  NetworkingClient
};
//# sourceMappingURL=index.mjs.map
